import { apiConstants } from './shared/config';

const authAccess = { roles: ['GEOAPI_00013'], redirect: {name: 'portal.login'}, forbiddenRedirect: '/portal/acesso-negado' };

const routes = [
    {
        path: `/${apiConstants.code}/home`,
        name: `${apiConstants.code}.home`,
        component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "geoapigestao" */ './views/Home.vue'),
        meta: {
            auth: {...authAccess},
            hideHeaderName: true,
            title: 'Gestão',
        }
    },
    {
        path: `/${apiConstants.code}/settings`,
        name: `${apiConstants.code}.settings`,
        component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "geoapigestao-settings" */ './views/settings/DefinitionsDetails.vue'),
        meta: {
            auth: {...authAccess, roles: ['GEOAPI_00021']},
            hideHeaderName: true,
            title: 'Configurações',
        }
    },
    {
        path: `/${apiConstants.code}/layers`,
        component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "geoapigestao-layers" */ './views/layer/LayerBase.vue'),
        children: [
            {
                path: '/',
                name: `${apiConstants.code}.layers`,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "geoapigestao-layers" */ './views/layer/LayerList.vue'),
                meta: {
                    auth: {...authAccess, roles: ['GEOAPI_00017']},
                    hideHeaderName: true,
                    title: 'layers.titles',
                }
            },
            {
                path: ':type',
                name: `${apiConstants.code}.layers.create`,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "geoapigestao-layers" */ './views/layer/LayerDetails.vue'),
                beforeEnter: (to, from, next) => {
                    let available = ['group', 'resource'];
                    if (available.indexOf(to.params.type) == -1){
                        next(false)
                    }else{
                        next();
                    }
                },
                meta: {
                    auth: {...authAccess, roles: ['GEOAPI_00014']},
                    hideHeaderName: true,
                    title: 'layers.title',
                }
            },
            {
                path: 'group/:id',
                name: `${apiConstants.code}.layers.show.group`,
                props: {isLayer: false},
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "geoapigestao-layers" */ './views/layer/LayerDetails.vue'),
                meta: {
                    auth: {...authAccess, roles: ['GEOAPI_00016']},
                    hideHeaderName: true,
                    title: 'layers.title',
                }
            },
            {
                path: 'resource/:id',
                name: `${apiConstants.code}.layers.show.item`,
                props: {isLayer: true},
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "geoapigestao-layers" */ './views/layer/LayerDetails.vue'),
                meta: {
                    auth: {...authAccess, roles: ['GEOAPI_00016']},
                    hideHeaderName: true,
                    title: 'layers.title',
                }
            },
        ],
        meta: {
            auth: {...authAccess, roles: ['GEOAPI_00017']},
            hideHeaderName: true,
            title: 'layers.titles',
        }
    },
];

export default routes;